import { render, staticRenderFns } from "./EventViewRegistrationSendReceiptModal.vue?vue&type=template&id=fa9de648&"
import script from "./EventViewRegistrationSendReceiptModal.vue?vue&type=script&lang=js&"
export * from "./EventViewRegistrationSendReceiptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports